import {UsuarioInfoNavLink} from '@components/contas/UsuarioInformacao.tsx';
import {RecursoInformacaoNavLink} from '@components/recurso/RecursoInformacao.tsx';
import {DefaultInformationProps} from "@models/DefaultProps.ts";
import {IRecursoMembro} from "@models/recurso/IRecursoMembro.ts";
import {Grid, TableCell, TableRow} from "@mui/material";
import React from 'react';

interface RecursoMembroInformacaoProps extends DefaultInformationProps<IRecursoMembro> {
	variant: 'list' | 'row';
}

export const RecursoMembroInformacao: React.FC<RecursoMembroInformacaoProps> = (props) => {
	const {variant} = props;

	if (variant === 'row')
		return <RecursoMembroInformacaoRow {...props}/>;
	if (variant == 'list')
		return <RecursoMembroInformacaoList {...props}/>;
};


export const RecursoMembroInformacaoList: React.FC<Omit<RecursoMembroInformacaoProps, 'overrides' | 'variant'>> = (props) => {
	const {
		value,
		EndComponent,
	} = props;

	return (<Grid size={12}>
		<Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
			<Grid size={'grow'} container>
				<Grid>{value.recurso &&
					<RecursoInformacaoNavLink value={value.recurso}/>}</Grid>
				<Grid>{value.usuarioId} {value.usuario?.nome}</Grid>
				<Grid>{value.funcaoRecursoId}</Grid>
			</Grid>
			{EndComponent && <Grid><EndComponent {...value}/></Grid>}
		</Grid>
	</Grid>);
};

export const RecursoMembroInformacaoRow: React.FC<Omit<RecursoMembroInformacaoProps, 'variant' | 'overrides'>> = (props) => {
	const {value, EndComponent} = props;

	return (
		<TableRow>
			<TableCell>{value.id}</TableCell>
			<TableCell>{value.recurso &&
				<RecursoInformacaoNavLink tableMode={true} value={value.recurso}/>}</TableCell>
			<TableCell>{value.usuario &&
				<UsuarioInfoNavLink slotProps={{chip: {tableMode: true}}} value={value.usuario}/>}</TableCell>
			<TableCell>{value.funcaoRecursoId}</TableCell>
			<TableCell align={'right'}>{EndComponent && <EndComponent {...value}/>}</TableCell>
		</TableRow>
	);
};